import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=2b6ddcaf&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=2b6ddcaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ddcaf",
  null
  
)

export default component.exports